import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('verticaltablist');

export { TAG_NAME };
